export default {
    // --------Title--------
    statesAndAreas: '州属和地区',
    definePreciseLocation: '定义精确位置',
    youHaveNotmakeAnySelection: '您尚未进行任何选择',

    // --------Drawer--------
    newArea: '添加地区',
    updateArea: '更新地区',

    // --------MUI--------
    sortName: '排序名称',
    phoneCode: '电话区号',
    states: '州属',
    areas: '地区'
};